<template>
<div>
    <h4 class="title is-5">Registro de actividad</h4>

<div id="activity_content" v-if="loaded">
    <table class="table is-fullwidth is-striped is-marginless">
        <thead>
            <tr class="has-text-justified">
                <th>
                    Fecha
                </th>
                <th></th>
                <th>Notificación</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(ac,n) in activity" :key="n" 
                :class="{
                    'has-text-left':true,
                    'has-background-success-light':ac.type == 1,
                    'has-background-danger-light':ac.type == 2,
                    'has-background-warning-light':ac.type == 3,
                    'has-background-link-light':ac.type == 4,
                    'has-background-warning':ac.type == 5
                }">
                <td>{{timeFormat(ac.date)}}</td>
                <td>
                    <span class="icon"> 
                        <fa icon="level-down-alt" class="has-text-success" v-if="ac.type == 1" /> 
                        <fa icon="level-up-alt" class="has-text-danger" v-if="ac.type == 2" /> 
                        <fa icon="medal" class="has-text-warning" v-if="ac.type == 3" />
                        <fa icon="award" class="has-text-link" v-if="ac.type == 4" /> 
                        <fa icon="coins" class="has-text-warning-dark" v-if="ac.type == 5" /> 
                    </span>
                </td>
                <td :class="{
                    'has-text-success-dark':ac.type == 1,
                    'has-text-danger-dark':ac.type == 2,
                    'has-text-warning-dark':ac.type == 3,
                    'has-text-link-dark':ac.type == 4,
                    'has-text-warning-dark':ac.type == 5
                }">{{ac.activity}}</td>
            </tr>
            <tr v-if="activity.length==0">
                <td>No hay actividad reciente.</td>
            </tr>
        </tbody>
    </table>
    <div class="has-background-white py-2 px-4">
        <content-pagination
            :max="pagination.pages"
            :current="pagination.current"
            @next-page="nextPage"
            @prev-page="prevPage"
            @set-page="setPageNumber" />
    </div>

</div>


<fa v-else icon="circle-notch" class="fa-4x has-text-white" spin />

</div>

</template>

<script>
import ContentPagination from '@/components/pagination/standard'
// import UserService from '@/services/user.service.js';
export default {
    name:'PlayerActivity',
    components: { ContentPagination },
    data:()=>({
      pagination: {
        next: '',
        previous: '',
        pages: 0,
        current: 1,
      },
      activity:[],
      loaded:false,
      extra:{}
    }),
    created() {
        this.$store.commit('changeDashboardPage', 5)
        this.makePage()
    },
    computed: {
        timeFormat() {
            return this.$store.getters.GetDateTimeFormat
        }
    },
    methods: {
      nextPage() {
          var path = this.pagination.next
          this.makePage(path)
      },
      prevPage() {
          var path = this.pagination.previous
          this.makePage(path)
      },
      setPageNumber(n) {
          this.makePage(null, n)
      },
      async makePage(url=null, page_number=0) {
          this.loaded = false
          this.extra = {url:url, page: page_number}
        //   let { data } = await UserService.getActivity(url, page_number)
          let data = this.$store.getters.GetJson('dashboard-activity')
          this.activity = data.results
          this.pagination = {
            next: data.links.next,
            previous: data.links.previous,
            pages:data.pages,
            current:data.current
          }
          this.loaded = true    
      },

    }
}
</script>

<style>

</style>